import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable, distinctUntilChanged, fromEvent, map, merge, take, takeUntil } from 'rxjs';
import { MatFormFieldControlImpl } from '../../ng-material-impl/mat-form-field-control.impl';
import { PasswordFormControlService } from '../password-form-control.service';


@Component({
  selector: 'ss-password-control',
  templateUrl: './password-control.component.html',
  styleUrls: ['./password-control.component.css'],
  providers: [
    { provide: MatFormFieldControl, useExisting: PasswordControlComponent }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordControlComponent extends MatFormFieldControlImpl<string> implements OnInit, AfterViewInit {


  @ViewChild('inputRef')
  private _inputRef!: ElementRef<HTMLInputElement>
  readonly hideTextSubject = this._passwordFormControlService.hideTextSubject;

  inputKeyObs!: Observable<Event>
  readonly valueSubject = this._formControlService.valueSubject;
  readonly touchedSubject = this._formControlService.touchedSubject;
  constructor(
    private readonly _passwordFormControlService: PasswordFormControlService
  ) {

    super('password')
  }

  ngAfterViewInit(): void {

    this.inputKeyObs = fromEvent<KeyboardEvent>(this._inputRef.nativeElement, 'keyup')
    const changeObs = fromEvent(this._inputRef.nativeElement, 'change')

    merge(this.inputKeyObs, changeObs)
      .pipe(
        map((evParams) => {
          const htmlInputElement = evParams.target as HTMLInputElement;
          const value = htmlInputElement.value;
          return value;
        }),
        distinctUntilChanged(),
        takeUntil(this._destroy)
      )
      .subscribe((value) => {
        this.valueSubject.next(value);
      })



    const focusOutObs = fromEvent<KeyboardEvent>(this._inputRef.nativeElement, 'focusout')

    focusOutObs.pipe(take(1), takeUntil(this._destroy)).subscribe(() => {
      this.touchedSubject.next(true)
    });


    this._formControlService.htmlElementSubject.next(this._inputRef.nativeElement);
  }

  ngOnInit(): void {

  }

  override onContainerClick(event: MouseEvent): void {
    this._inputRef.nativeElement.focus();
  }

  toggleVisiblity(evParams: Event) {

    this.hideTextSubject.next(!this.hideTextSubject.value)
    evParams.stopPropagation();
    evParams.preventDefault();
  }


}

